/**
 * PanesLayout.tsx - Card/Tile Layout for SectionNav
 * 
 * CHANGE HISTORY:
 * - 251115_1805 [current] danielbeer: Created panes layout
 */

import React from 'react';
import type { SectionLayoutProps } from '../types';

export const PanesLayout: React.FC<SectionLayoutProps> = ({
  sections,
  activeSection,
  onSectionClick
}) => {
  return (
    <div className="section-nav-panes">
      {sections.map((section) => (
        <button
          key={section.id}
          className={`section-pane ${activeSection === section.id ? 'section-pane--active' : ''} ${section.disabled ? 'section-pane--disabled' : ''}`}
          onClick={() => !section.disabled && onSectionClick(section)}
          disabled={section.disabled}
          aria-label={section.label}
          aria-pressed={activeSection === section.id}
        >
          {section.thumbnail && (
            <div className="section-pane__thumbnail">
              <img src={section.thumbnail} alt="" />
            </div>
          )}
          
          {section.icon && !section.thumbnail && (
            <div className="section-pane__icon" aria-hidden="true">
              {section.icon}
            </div>
          )}
          
          <div className="section-pane__content">
            <h3 className="section-pane__label">{section.label}</h3>
            {section.description && (
              <p className="section-pane__description">{section.description}</p>
            )}
          </div>
          
          {section.badge && (
            <span className="section-pane__badge" aria-label={`${section.badge} notifications`}>
              {section.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

PanesLayout.displayName = 'PanesLayout';
